const governmentLevels = Object.freeze({
  Federal: 1,
  State: 2,
});

export default governmentLevels;
